import React from 'react';

import { DropdownSingleSelectCustomTemplate } from 'components/pages/ModeReports/DropdownSingleSelectCustomTemplate/DropdownSingleSelectCustomTemplate';
import { StudyOptionContent } from 'components/pages/ModeReports/ModeReportsFilters/StudyOptionContent';

const StudyOptionTemplate = ({ option, setOptionsAsFavorite, favoriteOptions }) => (
  <DropdownSingleSelectCustomTemplate
    option={option}
    setOptionsAsFavorite={setOptionsAsFavorite}
    favoriteOptions={favoriteOptions}
  >
    <StudyOptionContent pcn={option?.pcn} name={option?.name} />
  </DropdownSingleSelectCustomTemplate>
);

export { StudyOptionTemplate };
